{
  // item-options-modal
  "onceOnly": "once only",
  "noLongerDeliver": "no longer deliver",
  "everyWeek": "every week (W)",
  "every2Weeks": "every 2 weeks (2W)",
  "every4Weeks": "every 4 weeks (4W)",
  "howOftenDelivery": "<b>How often</b> should the article be delivered?",
  "howManyUnits": "<b>How many</b> units of the article are to be delivered?",
  "firstTimeDelivery": "The article will be delivered for the <b>first time</b> on:",
  "nextTimeDelivery": "The article will be delivered <b>next time</b> on:",
  "oneTimeDelivery": "The article will be delivered <b>once</b> on:",
  "lastTimeDelivery": "The article will be delivered for the <b>last time</b> on:",
  "confirm": "Confirm",
  "deliveryDescription": "The item will be delivered at the selected interval, if available. You can adjust or pause your subscription anytime via the cart items or in your profile under 'Subscription Management'.",
  "postcodeError": "Address must belong to postcode: {postcode}",
  "missingStreetNumber": "Please provide a house number.",
  "noResultFromPlacesAPI": "No results found. Please try again.",
  "noCordinatesFoundForAddress": "Please re-type the address. We couldn't find exact address.",
  // payment-element-stripe
  "paymentMethods": "Payment Methods",
  "invoice": "Invoice",
  "sepa": "SEPA",
  "processing": "... Processing ...",
  // cart-summary
  "yourCartItemsWillBeLost": "Your cart items will be lost.",
  "rulesWillBeReset": "All rules will be reset.",
  "changeYourDeliveryToThisEarlierDate": "Change your delivery to this earlier date:",
  "timeLeftMessage": "You have {remaining_time} left to order. Order closes {closing_time_str}.",
  "switchToEarlierDelivery": "switch to earlier delivery",
  "switchDelivery": "Switch delivery",
  "soldOut": "Sold out. Please come back later.",
  "to": "to",
  "autobuyNotification": "Since you currently receive your shopping cart via subscription, you will not receive any order window or reminder emails.",
  "saveSettings": "Save settings",
  "orderWindowEmail": "Order window email",
  "reminderEmail": "Reminder email",
  "totalPrice": "Total Price",
  "waiveDeliveryFee": "free for orders above {waive_delivery_above}€",
  "orderDeadline": "Order deadline {remaining_str}",
  "orderDeadlineExpired": "Order deadline expired!",
  "deposit": "Deposit",
  "checkedOrdered": "✔ ordered",
  "resetChanges": "reset unordered changes",
  "cancelledOrPaused": "⨯ cancelled / paused",
  "cancelled": "⨯ cancelled",
  "deliveryFee": "Delivery fee",
  "shippingFee": "Shipping fee",
  "companyDeliverySubscription": "{company}-delivery subscription",
  "subscribeToCompanyDelivery": "subscribe to {company}-delivery",
  "subscribeEnabled": "You will receive your shopping cart by subscription at the selected periodicity. You can adjust the cart via the confirmation email or by logging in until the order deadline.",
  "subscribeDisabled": "Subscribe to {company}-delivery by adding products to the list below. Within the ordering window you can change in your cart or add any products from the catalog. Pause or cancel your subscription at any time.",
  // payment
  "payment_card": "Credit Card",
  "payment_sepa": "SEPA Direct Debit",
  "payment_invoice": "Invoice",
  "paymentErrorMessage": "Something went wrong with your payment method. Please try again or {contactLink} for assistance.",
  "contactSupport": "contact our support team",
  "favourites": "Favourites",
  "searchResults": "Search Results",

  "syncWithCartLabel": "Also change in current cart",
  "syncWithRuleLabel": "Change for all future carts",
  "adjustOrderForDate": "Adjust order for {date}",

  "periodicityError": "At least one choice has to be selected.",
  "amountError": "Number of units has to be at least 1.",

  "cart": "Cart",
  "setting": "Profile & Settings",

  "amountError": "Number of units has to be at least 1.",
  "systemChangePaymentMethod": "Due to a system change, please change payment method",
  "currentPaymentMethod": "Current payment method:",
  "accountHolder": "Account holder",
  "changePaymentMethod": "Change payment method",
  // PaymentInHouse
  "sepaMandate": "SEPA Direct Debit Mandate",
  "creditorIdentifier": "Creditor Identification: ",
  "mandateReferenceNumber": "Mandate reference number: ",
  "dealer": "Dealer",
  "mandateAuthorisationStatement": "By signing this mandate form, you authorise <strong>{gmbhName}</strong> to send instructions to your bank to debit your account and your bank to debit your account in accordance with the instructions from <strong>{gmbhName}</strong>.",
  "refundStatement": "<strong>Note:</strong> As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited",
  "confirmSepa": "I hereby confirm the SEPA direct debit mandate *",
  // cart-order-bar
  "inclusive": "inclusive",
  "exclusive": "exclusive",
  "vatText": "All prices are {incl_excl} VAT and exclusive deposit and delivery fee",
  "minSalesPriceText": "{remaining_to_min_sale_price}€ left until minimum order value",
  "ordered": "Ordered",
  "cartNotOrdered": "Cart was not ordered",
  "order": "Order",
  "editOrder": "Edit order",
  "cancel": "Cancel",
  "pause": "Pause",
  // catalog-item-list
  "categories": "Categories",
  "other": "Other",
  "suggestions": "Suggestions",
  // Ordering Info
  "expiredDeadlineMsg": "The order deadline has <strong>expired</strong>.",
  "newOrder": "Place a new order",
  "openOrderWindow": "Ordering window is open!",
  "closes": "closes",
  "orderingWindowExtended": "Ordering window was extended beyond previous ordering window deadline.",
  "oneTimeOrder": "Ordering is possible once.",
  "youCanCancelCart": "You can now cancel your cart.",
  "deliveryIsPaused": "Delivery is suspended.",
  "cartCancelled": "Cart has been cancelled.",
  "changeMind": "If you change your mind, add products within the ordering window and order as usual",
  "orderWindowOpens": "The ordering window opens <strong>{days_until_ordering_window_opens_str}</strong>",
  "reminderByEmail": "You will be reminded by email!",
  "activateReminder": "Turn on reminders in the settings!",
  "clickPause": "Click <strong>Pause</strong> to suspend your subscription for this delivery day.",
  "cartWithSubscribeRules": "This cart will be automatically purchased <strong>{days_until_ordering_window_opens_str}</strong> with products from your subscription",
  "cartWithProposalRules": "This cart will be automatically pre-filled <strong>{days_until_ordering_window_opens_str}</strong> with products from your selection.",
  "unlessYouOrderManually": "... unless you purchase this cart earlier",
  "contactNewOrder": "Contact {companyEmail} to place a new order",
  "welcomeInShop": "Welcome to {companyName} Shop.",
  "viewOrderingWindow": "View ordering window",
  "remainingTimeDays": "in {remaining_time} days",
  "remainingTimeHours": "in {remaining_time} hours",
  // SearchBar
  "searchPrompt": "Search Product",
  // Shop
  "checkDeliveryArea": "Check delivery area",
  "useDifferentBrowser": "Please use a different browser. The website is not optimized for Internet Explorer.",
  // CartHeader
  "selectDeliveryTime": "Select delivery time",
  // Welcome
  "backToShop": "Back to shop",
  "thankYou": "Thank you!",
  "successfulRegistration": "Your registration is successful.",
  "orderConfirmationMail": "You will receive an order confirmation by email shortly.",
  // Register
  "register": "Registration",
  // PickupForm
  "loginDetails": "Login details",
  "password": "Password",
  "passwordRequirement": "Password requires at least 6 characters including 1 number and 1 special character",
  "pickupAddress": "Pickup address",
  "streetAndHouseNumber": "Street & house number",
  "postcode": "Postcode",
  "city": "City",
  "timeslot": "Timeslots",
  "hintChanges": "Note: If you want to change the pickup store or have the item delivered to your door, please send an email to: {companyEmail}",
  "private": "private",
  "business": "commercial",
  "billingAddress": "Billing address",
  "countryCode": "Country code (DE)*",
  "phoneNumber": "Phone number*",
  "saveChanges": "Save changes",
  "saveAndContinue": "Save & Continue",
  "contactPerson": "Company contact person",
  "companyName": "Company name",
  // RequiredCaption
  "requiredFields": "* Required fields",
  // Profile
  "termsAndConditions": "terms and conditions ",
  "agreementPreamble": "*By placing the order I agree to the ",
  "ofCompany": "of {gmbhName}.",
  // DeliveryForm
  "deliveryAddress": "Delivery address",
  "shippingAddress": "Shipping address",
  "name": "Name",
  "surname": "Surname",
  "deliveryHints": "Delivery instructions - e.g. floor, backyard",
  "hintChangesDelivery": "Note: the {delivery_or_shipping_name} can only be adjusted in the same postal code area, if you want to change this, or if you would rather switch to one of our pick-up stations, please send an email to: {companyEmail}",
  "differentBillingAddress": "Billing address differs",
  // InputAutocomplete
  "streetAndHouseNumberAutocomplete": "Street & house number*",
  // Cart
  "havePatience": "Please be patient... ",
  "havePatienceWhileProcessing": "Please be patient, your order is being processed...",
  "successfulPaymentMethod": "Payment method successfully added.",
  "errorPaymentMethod": "Error entering payment method. Please try again.",
  "failedPaymentMethod": "The payment method could not be added. Please try again or choose a different payment method.",
  "unorderedChanges": "Cart has unordered changes.",
  "undoChanges": "Click here to reset unordered changes.",
  "saveUnorderedChanges": "To save the changes simply click on Order.",
  "adjustedProducts": "The following products in the cart have been adjusted due to lack of availability.",
  "cancelOrder": "Cancel Order",
  "cancelOrderConfirmation": "Are you sure you want to cancel this order?",
  "cancelOrderItemsWarning": "All items in your cart will be removed.",
  // CartController
  "orderConfirmation": "Thank you for your order, you will receive an order confirmation by email shortly.",
  "cancelConfirmation": "Order has been cancelled, you will receive a cancel confirmation by email shortly.",
  "pausedDelivery": "Delivery has been paused. If you change your mind, simply add products and order as usual",
  // CartItem
  "deposit_lc": "deposit",
  "nutritionML": "Nutritional values per 100ml",
  "nutritionG": "Nutritional values per 100g",
  "pieceCa": "Pc ca ",
  // PasswordReset
  "resetPswd": "Reset password",
  "successfulPswdReset": "Your password has been successfully reset",
  // ChangePassword
  "oldPswd": "Old password",
  "newPswd": "New password",
  "confirmNewPswd": "Confirm new password",
  "confirmChanges": "Confirm changes",
  // Contact
  "contactForQuestions": "If you have questions or feedback, you can reach us here:",
  "telephone": "Telephone",
  // DataProtection
  "dataProtectionHere": "Click here to view our data privacy policy:",
  "dataPrivacy": "Data privacy",
  // Deposit
  "overviewDeposit": "Deposit overview: ",
  "returnedAndCredited": " The following deposit items have been returned and will be credited with the next invoice. The prices include VAT ",
  "noCurrentReturns": "No deposit items have been returned at this time",
  "total": "TOTAL",
  // Email
  "loginEmail": "Login & correspondence Email",
  "billingEmailHint": "Billing email: only fill in if different from login email",
  "billingEmail": "Billing email",
  // Footer
  "impressum": "Impressum",
  "termsAndConditionsHc": "Terms and conditions",
  // CardProductTitle
  "contents": "Contents",
  // Invoices
  "receiptFrom": "Receipt from ",
  "invoiceFrom": "Invoice from ",
  // Login
  "enterPsw": "Please enter your password!",
  "forgotPsw": "Forgot password?",
  // NutritionPanel
  "ingredients": "Ingredients",
  "producerInfo": "Producer information",
  "productInfo": "Product information",
  "storageInfo": "Storage information",
  "usageInfo": "Usage information",
  // Rule
  "mySubscribedProducts": "My subscribed products",
  "addProductsToSubscription": "Add products to your subscription",
  "fillCartDescription": "All products that you select here will be automatically filled in your cart at the start of the order window, provided they are in stock.",

  "nextDeliveries": "My <b>next deliveries</b> for the following 4 weeks.",
  "pauseInstructions": "<b>To pause</b>, please deselect the corresponding date.",
  "datesSelectionError": "Please select at least one date.",
  "productManagement": "Product Management",
  "cannotDeselectSameDeliveryDate": "You cannot de-select this date because the ordering window is already open.",
  "pricesSubjectToChange": "* Prices are subject to change",
  "dateSelectedMessage": "You activated {date}. Your next delivery is scheduled for {nextDelivery}.",
  "dateSelectedMessageSameDate": "You activated {date}. Your next delivery remains scheduled for {nextDelivery}.",
  "dateDeselectedMessageSameDate": "You paused {date}. Your next delivery remains scheduled for {nextDelivery}.",
  "dateDeselectedMessage": "You paused {date}. Your next delivery is scheduled for {nextDelivery}.",
  "datePausedMessage": "You paused {date}. Your next delivery is scheduled for {nextDelivery}.",
  "datePausedMessageSameDate": "You paused {date}. Your next delivery remains scheduled for {nextDelivery}.",
  "scheduledDelivery": "Your next delivery is scheduled for: {date}",
  "soldLabel": "SOLD",
  "inactiveLabel": "CLOSED",
  "pausedLabel": "PAUSED",
  "noSearchResults": "No results found",
  "deliveringOn": "Delivering on: {date}",
  "notDeliveringOn": "Not delivering on: {date}",
  // Settings
  "subscription": "Subscription",
  "notifications": "Notifications",
  "invoiceTab": "Invoice",
  "addresses": "Addresses",
  "paymentMethod": "Payment method",
  "changePsw": "Change password",
  "contact": "Contact",
  "unlockMoreSettings": "More settings will be unlocked after purchasing the first cart.",
  // Terms
  "findTermsHere": "You can find our current terms and conditions here:",
  "all": "All",

  // UpcomingDeliveries
  "upcomingDeliveries": "Upcoming Deliveries",
  "noUpcomingDeliveries": "No upcoming deliveries found",
  "redirectingToCart": "Redirecting to cart...",
  "daysUntilDeadline": "{days} days until order deadline",
  "hoursUntilDeadline": "{hours} hours until order deadline",
  "orderDeadlinePassed": "Ordering/Cancelling not possible anymore",
  "weekdayMovedFrom": "| moved from {originalDay}",
  "filterOrdered": "Ordered",
  "filterPaused": "Paused/Cancelled",
  "filterEditable": "Editable",
  "clearFilter": "Clear filter",
  // Delivery Status
  "deliveryStatus.sold": "Ordered",
  "deliveryStatus.cancelled": "Cancelled",
  "deliveryStatus.paused": "Paused",
  "deliveryStatus.ordered": "Ordered",
  "deliveryStatus.open": "Open",
  "deliveryStatus.closed": "Closed",
  "deliveryStatus.delivered": "Delivered",
  // PastDeliveries
  "pastDeliveries": "Invoices & Past Deliveries",
  "weekNumber": "Week {number}",
  "pastDeliveriesOpen": "Open",
  "pastDeliveriesInvoiced": "Invoiced",
  "orderPausedCancelled": "Paused/Cancelled",
  // useDeliveries hook
  "weekday_1": "Monday",
  "weekday_2": "Tuesday",
  "weekday_3": "Wednesday",
  "weekday_4": "Thursday",
  "weekday_5": "Friday",
  "weekday_6": "Saturday",
  "weekday_7": "Sunday",
  "weekdayShort_1": "Mon",
  "weekdayShort_2": "Tue",
  "weekdayShort_3": "Wed",
  "weekdayShort_4": "Thu",
  "weekdayShort_5": "Fri",
  "weekdayShort_6": "Sat",
  "weekdayShort_7": "Sun",
  // Shared UI
  "totalAmount": "Total",
  "summe": "Total",
  "rechnung": "Invoice",
  "showMore": "Show More",
  "loading": "Loading...",
  "noDeliveriesInCategory": "No deliveries in this category",
  "noEntriesAvailable": "No entries available",
  "forceEditable": "Allow editing after order deadline",
  "backToMuli": "back to MULI",

  // Packing Notes
  "note": "Note",
  "addNoteToCart": "Add note to cart",
  "addNoteToCartPlaceholder": "Add special instructions for packing your order..."
}
